import { useQuery } from "@tanstack/react-query"
import { AccountReceivableControllerApi, GetAccountReceivableSummaryDateRangeEnum } from "../../services"
import { getConfigObject } from "../../utils/utils"

interface useAccountReceivableSummaryProps {
  dateRange?: GetAccountReceivableSummaryDateRangeEnum;
  startDate?: string;
  endDate?:string;
  xTENANTID:string | undefined;
}
export const useAccountReceivableSummary =({dateRange,startDate,endDate,xTENANTID}:useAccountReceivableSummaryProps)=>{
  return useQuery({
    queryKey:['account-receivable-summary',dateRange, startDate, endDate, xTENANTID],
    queryFn: async ()=> new AccountReceivableControllerApi(getConfigObject()).getAccountReceivableSummary(
      dateRange,
      startDate,
      endDate,
      xTENANTID
    ).then((res) => res?.data),
  })
}